/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { eDependencies } from './dependenciesE.generated.js';
import { createUppercaseE } from '../../factoriesAny.js';
export var EDependencies = {
  eDependencies,
  createUppercaseE
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesUppercaseE.generated.js
// module id = null
// module chunks = 